import {
  IHybridSettings,
  EGovProcedingType,
  EGovCategoryService,
  EGovPrintingMode,
  EGovOverprintMode,
  EGovReturnService,
  EGovShippingMode,
} from "dto/IHybridSettings";
import styles from "./styles.module.scss";

interface Props {
  value: IHybridSettings;
  onChange: (value: IHybridSettings) => void;
}

type Opt = { value: number; label: string };

const OPTS = {
  shippingMode: [
    { value: EGovShippingMode.Registered, label: "Rejestrowana" },
    { value: EGovShippingMode.NotRegistered, label: "Nierejestrowana" },
  ] as Opt[],
  procedingType: [
    { value: EGovProcedingType.General, label: "Ogólne" },
    { value: EGovProcedingType.Administrative, label: "Administracyjna" },
    { value: EGovProcedingType.Tax, label: "Podatki" },
    { value: EGovProcedingType.CourtCivil, label: "Sąd cywilny" },
    { value: EGovProcedingType.CourtCriminal, label: "Sąd karny" },
  ] as Opt[],
  categoryService: [
    { value: EGovCategoryService.Economic, label: "Ekonomiczna" },
    { value: EGovCategoryService.Priority, label: "Priorytetowa" },
  ] as Opt[],
  overprintMode: [
    { value: EGovOverprintMode.Monochrome, label: "Czarno-biały" },
    { value: EGovOverprintMode.Color, label: "Kolorowy" },
  ] as Opt[],
  printingMode: [
    { value: EGovPrintingMode.Duplex, label: "Druk dwustronny" },
    { value: EGovPrintingMode.Simplex, label: "Druk jednostronny" },
  ] as Opt[],
  returnService: [
    { value: EGovReturnService.ReturnToSender, label: "Zwrot do nadawcy" },
    { value: EGovReturnService.Destroy, label: "Zniszczyć" },
  ] as Opt[],
};

// Formatka opcji przesyłki hybrydowej (PUH) — odwzorowanie 6 pól z Magistratu.
const PuhOptionsPanel: React.FC<Props> = ({ value, onChange }) => {
  const set = (patch: Partial<IHybridSettings>) =>
    onChange({ ...value, ...patch });

  const field = (
    label: string,
    current: number,
    opts: Opt[],
    apply: (v: number) => void,
  ) => (
    <label className={styles.field}>
      <span className={styles.label}>{label}</span>
      <select
        className={styles.select}
        value={current}
        onChange={(e) => apply(Number(e.target.value))}
      >
        {opts.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>Opcje przesyłki hybrydowej (PUH)</div>
      <div className={styles.grid}>
        {field("Rodzaj przesyłki", value.ShippingMode, OPTS.shippingMode, (v) =>
          set({ ShippingMode: v }),
        )}
        {field(
          "Nadanie na zasadach specjalnych",
          value.ProcedingType,
          OPTS.procedingType,
          (v) => set({ ProcedingType: v }),
        )}
        {field("Priorytet", value.CategoryService, OPTS.categoryService, (v) =>
          set({ CategoryService: v }),
        )}
        {field("Rodzaj wydruku", value.OverprintMode, OPTS.overprintMode, (v) =>
          set({ OverprintMode: v }),
        )}
        {field("Druk", value.PrintingMode, OPTS.printingMode, (v) =>
          set({ PrintingMode: v }),
        )}
        {field(
          "Postępowanie przy niedostarczeniu",
          value.ReturnService,
          OPTS.returnService,
          (v) => set({ ReturnService: v }),
        )}
      </div>
      <label className={styles.checkboxRow}>
        <input
          type="checkbox"
          checked={value.ProofOfDelivery}
          onChange={(e) => set({ ProofOfDelivery: e.target.checked })}
        />
        <span>Potwierdzenie odbioru (ZPO)</span>
      </label>
    </div>
  );
};

export default PuhOptionsPanel;
